import "./Product.scss";
import CardProduct from "../../Component/Card/CardProduct.jsx";
import dataProduct from "./index.json";
import { ReactComponent as Divider } from "../../Assets/svg/divider.svg";
import Briza5images from "../../Assets/Produk/Briza/5x12/Briza5.js";
import Briza7Atticimages from "../../Assets/Produk/Briza/7x16/Briza7Attic.js";
import Briza7images from "../../Assets/Produk/Briza/7x12/Briza7.js";
import Havena8images from "../../Assets/Produk/Havena/8x15/Havena8.js";
import Havena10images from "../../Assets/Produk/Havena/10x15/Havena10.js";
import Havena10Atticimages from "../../Assets/Produk/Havena/10x18/Havena10Attic.js";
import Havena12images from "../../Assets/Produk/Havena/12x18/Havena12.js";
const imageMap = {
  Briza5images,
  Briza7Atticimages,
  Briza7images,
  Havena8images,
  Havena10images,
  Havena10Atticimages,
  Havena12images,
};
const Product = () => {
  return (
    <section className="section-produk" id="rumah">
      <div className="container">
        <Divider fill="#08325c" />
        <h2 className="title">Our Residentials</h2>
        <h3 className="sub-title" id="briza-lakes">
          Briza Lakes
        </h3>
        <div className="container-card">
          {dataProduct.cardsBriza.map((data, index) => (
            <CardProduct
              carousel={imageMap[data.imagesKey]}
              cardID={data.cardID}
              title={data.title}
              downPaymentType={data.downPaymentType}
              price={data.price}
              details={data.details}
              whatsappLink={data.whatsappLink}
            />
          ))}
        </div>
      </div>
      <div className="container">
        <h3 className="sub-title" id="havena-lakes">
          Havena Lakes
        </h3>
        <div className="container-card">
          {dataProduct.cardsHavena.map((data, index) => (
            <CardProduct
              carousel={imageMap[data.imagesKey]}
              cardID={data.cardID}
              title={data.title}
              downPaymentType={data.downPaymentType}
              price={data.price}
              details={data.details}
              whatsappLink={data.whatsappLink}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Product;
